export interface RecipientGrossRow {
  grossCommissionCents?: number;
}

/**
 * A single table cannot safely mix visible and hidden gross values. Show the
 * gross column only when every displayed row contains an authorised value.
 */
export function shouldShowRecipientGrossColumn(rows: RecipientGrossRow[]): boolean {
  return rows.length > 0 && rows.every((row) => row.grossCommissionCents !== undefined);
}
